import { Component, Input } from '@angular/core';

/**
 * Pure presentational component. Basic button used in many variations app-wide.
 */
@Component({
    selector: 'ssf-button',
    template: require('./basic-button.component.html'),
    styles: [require('./basic-button.component.scss')]
})
export class BasicButtonComponent {
    @Input() btnText: string;
    @Input() btnDisabled: boolean;
    @Input() btnReverted: boolean;
    @Input() iconPosition: string;
    /**
     * this is font-awesome specific name for icon, e.g. FA name is "fa-cross", attribute icon will be "cross"
     */
    @Input() icon: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/basic-button/basic-button.component.ts